import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { TRANSFER_SESSION, TRANSFER_SESSION_SUCCESS, TRANSFER_SESSION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* TransferSession({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { ticketId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/tickets/${ticketId}/transfer`,
      method: 'POST',
      data: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: TRANSFER_SESSION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: TRANSFER_SESSION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: TRANSFER_SESSION_ERROR, payload: error });
  }
}

export function* watchTransferSession() {
  yield takeEvery(TRANSFER_SESSION, TransferSession);
}

function* TransferSessionSaga() {
  yield all([fork(watchTransferSession)]);
}

export default TransferSessionSaga;
